<template>
  <el-card shadow="hover">
    <label slot="header">职业选择器</label>
    <el-divider content-position="left">value-type="String" separator="/": {{professionSelect}}</el-divider>
    <JProfession type="select" value-type="String" separator="/" v-model="professionSelect" placeholder="请选择行业" />
    <el-divider content-position="left">change返回值数组:{{keyArray}}|{{textArray}}</el-divider>
    <JProfession type="select" value-type="Array" v-model="professionArray" placeholder="请选择行业" @change="professionChange" />
    <el-divider content-position="left">文本解析 text-separator="#" 以#分隔显示</el-divider>
    <JProfession text-separator="#" :value="professionStr" />
  </el-card>
</template>

<script>
import JProfession from "@/components/JComponents/JProfession/JProfession.vue";
export default {
  components: {
    JProfession
  },
  data() {
    return {
      professionStr: '10000,10100',
      professionSelect: '',
      professionArray: '',
      keyArray: [],
      textArray: []
    }
  },
  methods: {
    professionChange (keyArray, textArray) {
      console.log(keyArray, textArray)
      this.keyArray = keyArray
      this.textArray = textArray
    }
  }
}
</script>
